import FormLayout from "../../../components/FormLayout";
import * as Sentry from '@sentry/react';
import { useSelector } from "react-redux";
import { RootState } from "../../../store/index";
import ErrorAndBackButton from "../../../components/ErrorAndBackButton";

const TaxReturnStateTransitionSorry = ({ actionCompletedButMessage }: {actionCompletedButMessage: string}) => {
  const { backendState: { status }} = useSelector((state: RootState) => state.state);
  Sentry.captureMessage("WrongTaxReturnState: " + status);

  const userFriendlyTaxReturnState = status.toLowerCase()
    .split('_')
    .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
    .join(' ');

  return (
    <FormLayout
      title={`Sorry`}
      subtitle={"Tax Return Status"}
      description={actionCompletedButMessage + "; however, your tax return status is considered " + userFriendlyTaxReturnState + ". The application was expecting a different state and cannot continue."}
    >
      <ErrorAndBackButton />
    </FormLayout>
  );
};

export default TaxReturnStateTransitionSorry;
